// De code in dit bestand wordt op elke pagina van je webite geladen

$w.onReady(function () {
$w("#copywriteText").text = "© " + new
Date().getFullYear().toString();
} );